// @core/api/endpoints/bootstrap/validate_step.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ValidateStepRequest,
  ValidateStepResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Validate wizard step
 * Validates the data for a specific wizard step without saving it. Returns validation errors if any.
 * @public This endpoint does not require authentication
 */
export async function ValidateStep(
  step_id: string,
  data: ValidateStepRequest,
  options?: RequestOptions
): Promise<ValidateStepResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/setup/steps/:step_id/validate`;
  requestPath = requestPath.replace(':step_id', encodeURIComponent(step_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.post<ValidateStepResponse>(requestPath, data, requestOptions);
}
